module.exports = __webpack_public_path__ + "7ad54fbc7defe8d61c0355beb40fbee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_180.png
// module id = 2466
// module chunks = 84